import { ConversationBase } from '../models/conversation-base.model';

export function sortByCustomerConnectedTimeAsc(a: ConversationBase, b: ConversationBase): number {
  return a.customerParticipant?.connectedTime?.localeCompare(b.customerParticipant?.connectedTime) ?? 0;
}
